import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UsuarioService } from '../../pages/administracao/clientes/usuarios/usuario.service';
import { PerfilService } from '../../pages/administracao/perfil/perfil.service';
import { ToastService } from '../../services/toast.service';
import { Perfil } from '../../types/Perfil.type';
import { Usuario } from '../../types/Usuario.type';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrl: './usuario.component.css'
})
export class UsuarioComponent implements OnInit {
  @Input() visivel: boolean = false;
  @Input() cliente: string = "";
  @Input() perfis: Perfil[] = []
  @Output() public fechar = new EventEmitter();

  @Input() usuario: Usuario = {} as Usuario;
  usuarioEnviado: boolean = false;

  loading: boolean = false;

  perfisSelecionados: Perfil[] = []

  constructor(private usuarioService: UsuarioService, private perfilService: PerfilService, private toastService: ToastService){}

  ngOnInit(){

    if(this.perfis.length == 0){
      this.perfilService.getAll().subscribe((data) => {
        this.perfis = data

        if(this.usuario != null){
          this.usuario.perfis.forEach((p) => {
            this.perfisSelecionados.push(p)
          })
        }
      })
    }
  }

  escondeDialog() {
    this.visivel = false;
    this.usuarioEnviado = false;
    this.usuario = {} as Usuario;

    this.fechar.emit();
  }


  salvar(){
    this.usuarioEnviado = true

    if(this.usuario.nomeUsuario?.trim() && this.usuario.email?.trim() && this.usuario.cdUsuarioErp && this.perfisSelecionados.length > 0){
      this.loading = true
    
      this.usuario.cliente = this.cliente
      this.usuario.perfis = this.perfisSelecionados

      this.usuarioService.post(this.usuario).subscribe({
        next: () => {
          this.toastService.sucesso("Sucesso", "Usuário salvo com sucesso");
          this.escondeDialog();

          this.loading = false
        },
        error: (erro) => {
          this.toastService.erro("Erro", "Erro ao salvar: " + erro.error);
          this.loading = false
        }
      })
    }
  }

}
